export const site = '/api-registre/'
//export const site = '/api-registre/public/index.php/'
//export const racine = 'http://localhost'
export const racine = 'https://lingevres.ddns.net'
//export const racine = 'https://solubac.ddns.net:446'
//export const racine = 'http://192.168.0.213'
